// En Home.js
import React from 'react';

function UserRegistration() {
  return <div>User Registration</div>;
}

export default UserRegistration;
